import { CloseIcon } from '../Icons';
import type { ReplyTarget } from '../../types/chat';
import { truncateQuoteText } from '../../types/chat';

interface QuotePreviewBarProps {
  quote: ReplyTarget;
  onDismiss: () => void;
}

export default function QuotePreviewBar({ quote, onDismiss }: QuotePreviewBarProps) {
  return (
    <div className="quote-preview-bar">
      <div className="quote-preview-accent" aria-hidden="true" />
      <div className="quote-preview-content">
        <span className="quote-preview-author">{quote.author}</span>
        <span className="quote-preview-text">{truncateQuoteText(quote.text, 80)}</span>
      </div>
      <button
        type="button"
        className="quote-preview-dismiss"
        onClick={onDismiss}
        title="Annuler la citation"
        aria-label="Annuler la citation"
      >
        <CloseIcon size={18} />
      </button>
    </div>
  );
}
